import { render } from "./QuickLinks.vue?vue&type=template&id=6bfa629c&ts=true"
import script from "./QuickLinks.vue?vue&type=script&lang=ts"
export * from "./QuickLinks.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__